import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box, Button, Optional } from '@honda-canada/design-system-react';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import themeStyles from './SpecialOfferCard.styles';
const CTAContainer = themeStyles.apply(Box, 'CTAContainer');
const BtnWrapper = themeStyles.apply(Box, 'BtnWrapper');
const StyledButton = themeStyles.apply(Button, 'StyledButton');
const CTAs = ({ primaryCta, secondaryCta }) => {
    const ctasWithTestIds = [
        {
            ...primaryCta,
            testId: 'cy-special-offer-card-primary-cta',
        },
        {
            ...secondaryCta,
            testId: 'cy-special-offer-card-secondary-cta',
        },
    ];
    return (_jsx(Optional, { when: primaryCta || secondaryCta, children: _jsx(CTAContainer, { children: _jsx(BtnWrapper, { children: ctasWithTestIds.map(({ styling, hrefSearch, linkType, href, target, text, testId }) => (_jsx(Optional, { when: href && text, children: _jsx(StyledButton, { "data-testid": testId, styling: styling, as: RoutableSitecoreLink, field: {
                            value: {
                                href,
                                target,
                                linktype: linkType,
                                querystring: hrefSearch,
                            },
                        }, children: text }) }, href))) }) }) }));
};
export default CTAs;
